import { render, staticRenderFns } from "./StoresPage.vue?vue&type=template&id=46b2ef3a&"
import script from "./StoresPage.vue?vue&type=script&lang=js&"
export * from "./StoresPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports